
import * as z from 'zod';

export const orderFormSchema = z.object({
  firstName: z.string().min(2, { message: 'First name must be at least 2 characters' }),
  lastName: z.string().min(2, { message: 'Last name must be at least 2 characters' }),
  companyName: z.string().min(2, { message: 'Company name is required' }),
  email: z.string().email({ message: 'Please enter a valid email address' }),
  phone: z.string().min(10, { message: 'Please enter a valid phone number' }),
  address: z.string().min(5, { message: 'Address must be at least 5 characters' }),
  city: z.string().min(2, { message: 'City must be at least 2 characters' }),
  state: z.string().min(2, { message: 'State must be at least 2 characters' }),
  zipCode: z.string().min(5, { message: 'Zip code must be at least 5 characters' }),
  country: z.string().min(2, { message: 'Country must be at least 2 characters' }),
  taxId: z.string().min(5, { message: 'Tax ID is required' }), // Modified to be required
  taxIdType: z.enum(['EIN', 'VAT', 'ABN', 'OTHER']),
  desiredSubdomain: z.string()
    .min(3, { message: 'Subdomain must be at least 3 characters' })
    .max(30, { message: 'Subdomain must be less than 30 characters' })
    .regex(/^[a-z0-9]([a-z0-9-]{1,28}[a-z0-9])?$/, { 
      message: 'Subdomain can only contain lowercase letters, numbers, and hyphens, and cannot start or end with a hyphen' 
    }),
  agreeTerms: z.literal(true, {
    errorMap: () => ({ message: 'You must agree to the terms and conditions' }),
  }),
});

export type OrderFormValues = z.infer<typeof orderFormSchema>;
